<template>
    <div>
        <div class="relative qrcode-decoder" v-show="showSubmit == false">
            {{ error }}
            <qrcode-stream @decode="onDecode" @init="onInit" />
            <form class="absolute w-full max-h-screen min-h-screen qrcode-form" method="POST" @submit="formSubmit">
                <slot></slot> 
                <textarea class="h-0 p-0 m-0 qrcode-input" v-model="result"></textarea>
                <button @click="showSubmit = ! showSubmit" type="submit" value="Conferma" :class="{ 'is-filled': result !== '' }"  class="block w-full p-2 m-auto text-center text-white bg-green-600 rounded button">{{ $t('Submit') }}</button>
            </form>
        </div>
        <div v-if="showSubmit == true && showDone == false">
            <CircleProgress />
            <form @submit.prevent="submit">
                <slot></slot>
                <button type="submit" class="relative flex-grow w-full px-4 py-2 m-1 mt-8 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 focus:outline-none focus:shadow-outline md:flex-1">
                    {{ $t('save the results') }}
                </button>
            </form>
        </div>
        <div v-if="showDone == true">
            <button class="relative flex-grow w-full px-4 py-2 m-1 mt-8 font-bold text-white bg-green-600 rounded focus:outline-none focus:shadow-outline md:flex-1">
                {{ $t('operation complete') }}
            </button>
        </div>
    </div>
</template>

<script>
    import { QrcodeStream } from "vue-qrcode-reader";
    import CircleProgress from "@/Components/CircleProgress";

    export default {
        props: ['user'],
        components: { QrcodeStream,CircleProgress },
        data () {
            return {
                student: this.user,
                result: '',
                error: '',
                showSubmit: false,
                showDone: false,
                sending: false,
                form: {
                    student: this.user,
                },
            }
        },
        methods: {
            onDecode (result) {
                this.result = result
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            formSubmit(e) {
                e.preventDefault();
                axios.post('/submitqr', {
                    result: this.result,
                    student:this.student
                })
            },
            submit() {
                this.showDone = !this.showDone;
                this.$inertia.post(this.route("adminsurvey"), this.form, {
                    onStart: () => (this.sending = true),
                    onFinish: () => (this.sending = false),
                });
            },
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }
    .qrcode-input {
        visibility: hidden;
    }
    .button {
        display: none;
    }
    .button.is-filled {
        display: block;
        margin: 0 auto; 
    }
</style>